import React from 'react';
import * as PropTypes from 'prop-types';

const RecentDeal = ({content:{ amount, bids, item_deal_url, item_image_featured},onClickEvent}) => {
  const linkProps = { className:'deal', href:item_deal_url, onClick:onClickEvent, 'data-label':'Explore marketplace - Ring','data-section':'RecentDeal'};
  const backgroundImage = item_image_featured ? {backgroundImage:'url('+item_image_featured+')'} : null;

  return (
      <a {...linkProps}>
        <div className="pic" style={backgroundImage}/>
        <div className="sold">SOLD</div>
        <div className="price-n-bids">
          <span className="price">{amount}</span>
          <span className="bids">{bids} interested buyers</span>
        </div>
      </a>
  )
};

RecentDeal.propTypes = {
  content:PropTypes.object,
  onClickEvent:PropTypes.func
};

export default RecentDeal